'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var DEFAULT_VISIBLE_OPTIONS = 5;
var SIZE_TO_CLASSNAME_MAP = {
    s: 'size-48',
    m: 'size-56',
    l: 'size-64',
    xl: 'size-72',
    48: 'size-48',
    56: 'size-56',
    64: 'size-64',
    72: 'size-72',
};

exports.DEFAULT_VISIBLE_OPTIONS = DEFAULT_VISIBLE_OPTIONS;
exports.SIZE_TO_CLASSNAME_MAP = SIZE_TO_CLASSNAME_MAP;
